(function(){
  var d=document, root=d.documentElement;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  clearTimeout(window.__rv); // JS loaded: cancel the "show everything" safety net

  /* ---------- header height (keeps sticky columns clear of the sticky header) ---------- */
  var hd=d.querySelector('[data-header]');
  function hh(){ if(hd) root.style.setProperty('--hd-h',hd.offsetHeight+'px'); }
  hh(); window.addEventListener('resize',hh); window.addEventListener('load',hh);

  /* ---------- mobile menu + sort ---------- */
  var t=d.querySelector('[data-menu-toggle]'), nav=d.querySelector('[data-nav]');
  if(t&&nav){t.addEventListener('click',function(){var o=nav.classList.toggle('open');t.setAttribute('aria-expanded',o);});}
  var s=d.querySelector('[data-sort]');
  if(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString();});}

  /* ---------- scroll reveal (product page) ---------- */
  var RV='body.template-product main :is(.sec-title,.trust-grid>div,.review,.faq details,.grid>.card)';
  function reveal(){
    var els=d.querySelectorAll(RV); if(!els.length) return;
    var instant=reduce||!('IntersectionObserver' in window);
    if(instant){els.forEach(function(e){e.classList.add('rv-done');});return;}
    var io=new IntersectionObserver(function(entries){
      var n=0;
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        var el=en.target, delay=n*90; n++;
        el.style.setProperty('--d',delay+'ms'); el.classList.add('in'); io.unobserve(el);
        setTimeout(function(){el.classList.remove('in');el.classList.add('rv-done');el.style.removeProperty('--d');},900+delay);
      });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){ if(!e.classList.contains('rv-done')&&!e.classList.contains('in')) io.observe(e); });
  }

  /* ---------- smooth accordions (FAQ + product details) ---------- */
  function accordions(){
    d.querySelectorAll('details.acc,.faq details').forEach(function(det){
      if(det._acc) return; det._acc=1;
      var sum=det.querySelector('summary'); if(!sum) return;
      sum.addEventListener('click',function(e){
        e.preventDefault(); if(det._a) return;
        var closing=det.open;
        if(reduce||!det.animate){det.open=!closing;return;}
        var from=det.offsetHeight, to;
        det.style.overflow='hidden';
        if(closing){det.open=false;to=det.offsetHeight;det.open=true;det.classList.add('is-closing');}
        else{det.open=true;to=det.offsetHeight;}
        det._a=det.animate([{height:from+'px'},{height:to+'px'}],{duration:380,easing:'cubic-bezier(.22,.7,.2,1)'});
        det._a.onfinish=det._a.oncancel=function(){det.open=!closing;det.classList.remove('is-closing');det.style.height=det.style.overflow='';det._a=null;};
      });
    });
  }
  /* ---------- 3D tilt (mouse-driven, desktop pointers only) ---------- */
  function tilt(el,max){
    if(el._t) return; el._t=1; el.setAttribute('data-tilt','');
    el.addEventListener('mouseenter',function(){el.classList.add('tilting');});
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect(), x=(e.clientX-r.left)/r.width, y=(e.clientY-r.top)/r.height;
      el.style.setProperty('--ry',((x-.5)*2*max).toFixed(2)+'deg');
      el.style.setProperty('--rx',((.5-y)*2*max).toFixed(2)+'deg');
      el.style.setProperty('--gx',(x*100).toFixed(1)+'%'); el.style.setProperty('--gy',(y*100).toFixed(1)+'%');
    });
    el.addEventListener('mouseleave',function(){el.classList.remove('tilting');el.style.setProperty('--rx','0deg');el.style.setProperty('--ry','0deg');});
  }
  function tilts(){
    if(reduce||!window.matchMedia||!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    d.querySelectorAll('.pdp-main').forEach(function(e){tilt(e,7);});
    d.querySelectorAll('body.template-product .card,body.template-product .review,body.template-product .trust-grid>div').forEach(function(e){tilt(e,8);});
  }
  /* ---------- scroll-driven 3D (touch screens: elements lean as they travel through the viewport) ---------- */
  var S3='.pdp-main,body.template-product .review,body.template-product .grid>.card,body.template-product .trust-grid>div';
  var s3on=false, s3tick=false;
  function s3frame(){
    s3tick=false; var vh=window.innerHeight;
    d.querySelectorAll('.s3d').forEach(function(e,i){
      var r=e.getBoundingClientRect(); if(r.bottom<-120||r.top>vh+120) return;
      var c=Math.max(-1,Math.min(1,(r.top+r.height/2-vh/2)/(vh/2)));
      e.style.setProperty('--rx',(c*14).toFixed(2)+'deg');
      e.style.setProperty('--ry',((i%2?1:-1)*c*5).toFixed(2)+'deg');
    });
  }
  function scroll3d(){
    if(reduce||(window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches)) return;
    d.querySelectorAll(S3).forEach(function(e){e.setAttribute('data-tilt','');e.classList.add('s3d');});
    if(!s3on){s3on=true;window.addEventListener('scroll',function(){if(!s3tick){s3tick=true;requestAnimationFrame(s3frame);}},{passive:true});window.addEventListener('resize',s3frame);}
    s3frame();
  }
  reveal(); accordions(); tilts(); scroll3d();
  d.addEventListener('shopify:section:load',function(){reveal();accordions();tilts();scroll3d();});

  /* ---------- product page ---------- */
  var p=d.querySelector('[data-product]');
  if(!p) return;
  var variants=JSON.parse(p.querySelector('[data-variants]').textContent);
  var stockMap={}; try{stockMap=JSON.parse(p.querySelector('[data-stock]').textContent);}catch(e){}
  var form=p.querySelector('form'), idInput=p.querySelector('[data-variant-id]');
  var addBtn=p.querySelector('[data-add]'), label=addBtn.querySelector('[data-add-label]');
  var priceEl=p.querySelector('[data-price]'), stockEl=p.querySelector('[data-stock-msg]'), badge=p.querySelector('[data-badge]');
  var q=p.querySelector('input[name=quantity]');
  var bar=d.querySelector('[data-bar]'), barBtn=d.querySelector('[data-bar-add]');
  var barPrice=d.querySelector('[data-bar-price]'), barOpts=d.querySelector('[data-bar-opts]');
  var stage=p.querySelector('[data-stage]'), main=d.getElementById('PdpMain');
  var cartUrl=p.dataset.cartUrl||'/cart', addUrl=(p.dataset.addUrl||'/cart/add')+'.js';
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  var money=function(c){try{return new Intl.NumberFormat(d.documentElement.lang||'en',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(c/100);}catch(e){return (c/100).toFixed(2);}};
  var ease='cubic-bezier(.22,.7,.2,1)';

  /* gallery */
  var thumbs=[].slice.call(p.querySelectorAll('[data-thumb]'));
  var imgs=thumbs.map(function(b){return {src:b.dataset.thumb,full:b.dataset.full||b.dataset.thumb};});
  if(!imgs.length&&main) imgs=[{src:main.getAttribute('src'),full:main.dataset.full||main.getAttribute('src')}];
  var idx=Math.max(0,thumbs.findIndex(function(b){return b.classList.contains('on');}));
  var curEl=p.querySelector('[data-cur]'), token=0;
  if(main){
    if(main.complete) stage.classList.add('is-loaded'); else main.addEventListener('load',function(){stage.classList.add('is-loaded');});
  }
  function setImage(i){
    if(!imgs.length) return;
    i=(i+imgs.length)%imgs.length; idx=i;
    thumbs.forEach(function(b,k){b.classList.toggle('on',k===i);});
    if(thumbs[i]&&thumbs[i].scrollIntoView&&!reduce){var tb=thumbs[i].parentNode; if(tb.scrollWidth>tb.clientWidth) tb.scrollTo({left:thumbs[i].offsetLeft-tb.clientWidth/2+thumbs[i].offsetWidth/2,behavior:'smooth'});}
    if(curEl) curEl.textContent=i+1;
    if(!main||main.getAttribute('src')===imgs[i].src) return;
    var my=++token, inc=new Image();
    inc.className='pdp-img incoming'; inc.alt=main.alt; inc.decoding='async'; inc.dataset.full=imgs[i].full;
    inc.onload=function(){
      if(my!==token) return;
      stage.insertBefore(inc,main.nextSibling);
      requestAnimationFrame(function(){requestAnimationFrame(function(){inc.classList.add('show');});});
      setTimeout(function(){
        if(my!==token){inc.remove();return;}
        main.remove(); inc.id='PdpMain'; inc.classList.remove('incoming','show'); main=inc;
      },reduce?0:620);
    };
    inc.src=imgs[i].src;
  }
  thumbs.forEach(function(b,k){b.addEventListener('click',function(){setImage(k);});});
  var prev=p.querySelector('[data-prev]'), next=p.querySelector('[data-next]');
  if(prev) prev.addEventListener('click',function(e){e.stopPropagation();setImage(idx-1);});
  if(next) next.addEventListener('click',function(e){e.stopPropagation();setImage(idx+1);});

  /* swipe on touch */
  if(stage&&imgs.length>1){
    var sx=0,sy=0,moved=false;
    stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;moved=false;},{passive:true});
    stage.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-sx, dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){moved=true;setImage(idx+(dx<0?1:-1));stage._swiped=Date.now();}
    },{passive:true});
  }

  /* hover zoom (desktop pointers only) */
  if(stage&&p.dataset.zoom==='true'&&window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches){
    stage.addEventListener('mouseenter',function(){stage.classList.add('zoomed');});
    stage.addEventListener('mouseleave',function(){stage.classList.remove('zoomed');});
    stage.addEventListener('mousemove',function(e){
      var r=stage.getBoundingClientRect();
      stage.style.setProperty('--zx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');
      stage.style.setProperty('--zy',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');
    });
  }

  /* lightbox */
  var lb=null, lbImg, lbCount, lastFocus;
  function buildLb(){
    lb=d.createElement('div'); lb.className='lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true'); lb.setAttribute('aria-label','Product images');
    var ic=function(path){return '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+path+'</svg>';};
    lb.innerHTML='<button type="button" class="lb-x" aria-label="Close">'+ic('<path d="M6 6l12 12M18 6 6 18"/>')+'</button>'+
      (imgs.length>1?'<button type="button" class="lb-nav lb-prev" aria-label="Previous image">'+ic('<path d="m15 5-7 7 7 7"/>')+'</button><button type="button" class="lb-nav lb-next" aria-label="Next image">'+ic('<path d="m9 5 7 7-7 7"/>')+'</button><span class="lb-count"></span>':'')+
      '<img alt="">';
    d.body.appendChild(lb); lbImg=lb.querySelector('img'); lbCount=lb.querySelector('.lb-count');
    lb.addEventListener('click',function(e){
      if(e.target.closest('.lb-x')||e.target===lb) closeLb();
      else if(e.target.closest('.lb-prev')) lbGo(-1);
      else if(e.target.closest('.lb-next')) lbGo(1);
    });
  }
  function lbShow(){
    lbImg.classList.remove('swap'); void lbImg.offsetWidth;
    lbImg.src=imgs[idx].full; lbImg.alt=(main&&main.alt)||''; lbImg.classList.add('swap');
    if(lbCount) lbCount.textContent=(idx+1)+' / '+imgs.length;
  }
  function lbGo(n){setImage(idx+n);lbShow();}
  function openLb(){
    if(!imgs.length) return; if(!lb) buildLb();
    lastFocus=d.activeElement; lbShow();
    requestAnimationFrame(function(){lb.classList.add('open');}); d.body.style.overflow='hidden';
    lb.querySelector('.lb-x').focus();
  }
  function closeLb(){ if(!lb) return; lb.classList.remove('open'); d.body.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
  d.addEventListener('keydown',function(e){
    if(!lb||!lb.classList.contains('open')) return;
    if(e.key==='Escape') closeLb();
    else if(e.key==='ArrowLeft'&&imgs.length>1) lbGo(-1);
    else if(e.key==='ArrowRight'&&imgs.length>1) lbGo(1);
  });
  if(stage){
    stage.addEventListener('click',function(e){
      if(e.target.closest('.pdp-nav')) return;
      if(stage._swiped&&Date.now()-stage._swiped<400) return;
      openLb();
    });
    var ex=p.querySelector('[data-expand]'); if(ex) ex.addEventListener('click',function(e){e.stopPropagation();openLb();});
  }

  /* quantity */
  function maxQty(){var v=cur(); var n=v?stockMap[v.id]:null; return (n!=null&&n>0)?n:Infinity;}
  p.querySelectorAll('[data-qty]').forEach(function(b){b.addEventListener('click',function(){
    var n=Math.min(maxQty(),Math.max(1,(parseInt(q.value,10)||1)+parseInt(b.dataset.qty,10)));
    if(String(n)!==q.value){q.value=n;q.classList.remove('tick');void q.offsetWidth;q.classList.add('tick');}
  });});

  /* variants */
  function selected(){return [].map.call(p.querySelectorAll('.opt'),function(f){var c=f.querySelector('input:checked');return c?c.value:null;});}
  function cur(){var sel=selected(); return variants.find(function(x){return x.options.every(function(o,i){return o===sel[i];});})||(variants.length===1?variants[0]:null);}
  function markAvail(){
    var sel=selected();
    p.querySelectorAll('.opt').forEach(function(f,i){
      f.querySelectorAll('input').forEach(function(inp){
        var ok=variants.some(function(v){return v.options[i]===inp.value&&v.available&&v.options.every(function(o,j){return j===i||o===sel[j];});});
        inp.nextElementSibling.classList.toggle('na',!ok);
      });
      var sl=f.querySelector('[data-sel]'); if(sl&&sel[i]!=null) sl.textContent=sel[i];
    });
  }
  function setBtns(text,disabled){
    label.textContent=text; addBtn.disabled=disabled;
    if(barBtn){barBtn.querySelector('.btn-label').textContent=text; barBtn.disabled=disabled;}
  }
  function stock(v){
    if(!stockEl) return;
    var n=stockMap[v.id], th=parseInt(p.dataset.threshold,10)||5;
    if(v.available&&n!=null&&n>0&&n<=th){
      stockEl.hidden=false;
      stockEl.querySelector('[data-stock-text]').textContent=n===1?'Only 1 left in stock':'Only '+n+' left in stock — order soon';
      var bar_=stockEl.querySelector('i'); bar_.style.animation='none'; void bar_.offsetWidth; bar_.style.animation=''; bar_.style.setProperty('--s',Math.max(.08,n/th));
    } else stockEl.hidden=true;
  }
  function update(init){
    markAvail();
    var v=cur();
    if(!v){setBtns('Unavailable',true);return;}
    idInput.value=v.id; setBtns(v.available?'Add to cart':'Sold out',!v.available);
    var onSale=v.compare_at_price>v.price;
    priceEl.className='pdp-price'+(onSale?' sale':'');
    priceEl.innerHTML='<span class="now">'+money(v.price)+'</span>'+(onSale?'<s class="was">'+money(v.compare_at_price)+'</s><span class="save">Save '+Math.round((v.compare_at_price-v.price)/v.compare_at_price*100)+'%</span>':'');
    if(badge) badge.hidden=!onSale;
    if(barPrice) barPrice.textContent=money(v.price);
    if(barOpts) barOpts.textContent=p.querySelector('.opt')?' · '+v.options.join(' / '):'';
    stock(v);
    var mq=maxQty(); if((parseInt(q.value,10)||1)>mq) q.value=mq;
    if(init) return;
    priceEl.classList.add('swap');
    if(v.featured_image){
      var key=function(u){return String(u).split('?')[0].replace(/^https?:/,'');}, k=key(v.featured_image.src);
      var at=imgs.findIndex(function(im){return key(im.src)===k;});
      if(at<0&&v.featured_image.position&&imgs[v.featured_image.position-1]) at=v.featured_image.position-1;
      if(at>=0) setImage(at);
    }
    var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
  }
  p.addEventListener('change',function(e){if(e.target.closest('.opt'))update();});
  update(true);

  /* ---------- toast + cart count ---------- */
  var toastTimer;
  function toast(o){
    var old=d.querySelector('.toast'); if(old) old.remove();
    var el=d.createElement('div'); el.className='toast'+(o.error?' toast-err':''); el.setAttribute('role',o.error?'alert':'status');
    var thumb=o.img?'<img src="'+esc(o.img)+'" alt="" width="56" height="70">':'<span></span>';
    el.innerHTML=thumb+'<div><strong>'+(o.error?'':'<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>')+esc(o.title)+'</strong><p class="toast-t">'+esc(o.text)+'</p>'+
      (o.error?'':'<div class="toast-act"><a class="btn btn-sm" href="'+esc(cartUrl)+'">View cart</a><button type="button" class="link-under toast-x">Keep shopping</button></div>')+'</div><i class="toast-bar"></i>';
    d.body.appendChild(el);
    function close(){clearTimeout(toastTimer);el.classList.add('out');setTimeout(function(){el.remove();},320);}
    var x=el.querySelector('.toast-x'); if(x) x.addEventListener('click',close);
    el.querySelector('.toast-bar').addEventListener('animationend',close);
    if(o.error) setTimeout(close,6000);
  }
  function setCount(n){
    d.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;el.hidden=n<1;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump');});
    d.querySelectorAll('.cart-link').forEach(function(a){a.setAttribute('aria-label','Cart, '+n+' items');});
  }

  /* ---------- add to cart (AJAX) ---------- */
  var busy=false;
  function state(cls){[addBtn,barBtn].forEach(function(b){if(!b)return;b.classList.remove('is-loading','is-added');if(cls)b.classList.add(cls);});}
  function ripple(btn,e){
    if(reduce) return;
    var r=btn.getBoundingClientRect(), s=Math.max(r.width,r.height)*2, sp=d.createElement('span');
    sp.className='ripple'; sp.style.cssText='width:'+s+'px;height:'+s+'px;left:'+((e.clientX||r.left+r.width/2)-r.left-s/2)+'px;top:'+((e.clientY||r.top+r.height/2)-r.top-s/2)+'px';
    btn.appendChild(sp); setTimeout(function(){sp.remove();},650);
  }
  [addBtn,barBtn].forEach(function(b){if(b)b.addEventListener('pointerdown',function(e){if(!b.disabled)ripple(b,e);});});
  if(barBtn) barBtn.addEventListener('click',function(){addBtn.click();});

  form.addEventListener('submit',function(e){
    if(e.submitter&&!e.submitter.hasAttribute('data-add')) return; // dynamic checkout buttons keep default behaviour
    if(!window.fetch||!window.FormData) return;
    e.preventDefault(); if(busy||addBtn.disabled) return;
    busy=true; state('is-loading');
    var v=cur(), imgSrc=main&&main.getAttribute('src'), minWait=new Promise(function(r){setTimeout(r,450);});
    fetch(addUrl,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok) throw {friendly:res.j&&(res.j.description||res.j.message)||'Could not add this item.'};
        return Promise.all([fetch(cartUrl+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}),minWait]).then(function(a){return {cart:a[0],item:res.j};});
      })
      .then(function(r){
        setCount(r.cart.item_count); state('is-added');
        var opts=r.item.variant_title&&r.item.variant_title!=='Default Title'?' · '+r.item.variant_title:'';
        toast({title:'Added to your cart',text:(r.item.quantity>1?r.item.quantity+' × ':'')+r.item.product_title+opts,img:imgSrc});
        setTimeout(function(){state('');busy=false;},2200);
      })
      .catch(function(err){
        state(''); busy=false;
        if(err&&err.friendly) toast({error:true,title:'Couldn\u2019t add to cart',text:err.friendly});
        else form.submit(); // network failure: fall back to normal form post
      });
  });

  /* ---------- sticky add-to-cart bar ---------- */
  if(bar&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var gone=!en[0].isIntersecting&&en[0].boundingClientRect.top<0;
      bar.classList.toggle('show',gone); bar.setAttribute('aria-hidden',!gone);
      if(barBtn) barBtn.tabIndex=gone?0:-1;
      d.body.classList.toggle('has-bar',gone);
    },{threshold:0}).observe(addBtn);
  }
})();
